import { Box, Button, Card, Stack, Text } from '@mantine/core';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { FormPageLayout } from '@flexinet/ui-components';
import { enableBillingProviderForCurrentCustomer } from '../services/BillingProvidersService';
import { fetchEnabledBillingProviders } from '../services/BillingProvidersService';

export const ProviderSetupPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const providerKey = searchParams.get('providerKey') || 'stripe';

    const setupMutation = useMutation({
        mutationFn: async () => {
            const providers = await fetchEnabledBillingProviders();
            const provider = providers.find((p) => p.key === providerKey);
            
            if (!provider) throw new Error(`Provider ${providerKey} not found`);

            // Billing API handles provider customer creation for current user
            await enableBillingProviderForCurrentCustomer(provider.id);
        },
        onSuccess: () => {
            const params = new URLSearchParams(searchParams);
            navigate(`/billing/payment-method-setup?${params.toString()}`);
        }
    });

    const providerName = providerKey === 'paypal' ? 'PayPal' : 'Stripe';

    return (
        <FormPageLayout title="Connect Payment Provider" pageNavigation={<Box />}>
            <Stack gap="lg" p="md" maw={600} mx="auto">
                <Card withBorder p="xl">
                    <Stack gap="md">
                        <Text size="xl" fw={600}>Connect to {providerName}</Text>
                        <Text size="sm" c="dimmed">
                            Connect your account to {providerName} to enable payment processing.
                        </Text>
                        <Button
                            onClick={() => setupMutation.mutate()}
                            loading={setupMutation.isPending}
                            size="lg"
                            fullWidth
                        >
                            Connect {providerName} Account
                        </Button>
                    </Stack>
                </Card>
            </Stack>
        </FormPageLayout>
    );
};
